"use client";

import { m as motion, useReducedMotion } from "framer-motion";

type Props = {
  label: string;
};

export function ScrollIndicator({ label }: Props) {
  const prefersReduced = useReducedMotion();

  return (
    <div
      aria-hidden
      className="absolute bottom-7 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-[10px] font-mono text-[11px] uppercase text-fg3 md:flex"
      style={{ letterSpacing: "0.2em" }}
    >
      <span>{label}</span>
      <div
        className="relative h-11 w-px overflow-hidden"
        style={{
          background:
            "linear-gradient(180deg, transparent, var(--brand-azure) 50%, transparent)",
        }}
      >
        {!prefersReduced ? (
          <motion.span
            className="absolute left-0 right-0 h-5"
            style={{
              background:
                "linear-gradient(180deg, transparent, var(--brand-cyan))",
            }}
            initial={{ top: "-20px", opacity: 1 }}
            animate={{ top: "100%", opacity: 0 }}
            transition={{
              duration: 1.8,
              ease: [0.22, 1, 0.36, 1],
              repeat: Infinity,
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
